import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllRanksTable from './components/AllRanksTable';

function RankPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Ränge" />
      <ErrorBoundaries>
        <AllRanksTable />
      </ErrorBoundaries>
    </>
  );
}

export default RankPage;
